import { SelectHTMLAttributes } from "react";

type SelectOption = {
	value: string;
	label: string;
};

type SelectFieldProps = SelectHTMLAttributes<HTMLSelectElement> & {
	label: string;
	options: SelectOption[];
	placeholder?: string;
	placeholderDisabled?: boolean;
	className?: string;
	hideLabel?: boolean;
};

export function SelectField({
	label,
	options,
	placeholder = "Select",
	placeholderDisabled = false,
	className = "",
	hideLabel = false,
	id,
	...props
}: SelectFieldProps) {
	const selectId = id ?? label.toLowerCase().replace(/[^a-z0-9]+/g, "-");

	return (
		<div className={`pf-field-group ${className}`.trim()}>
			{hideLabel ? null : (
				<label className="pf-field-group__label" htmlFor={selectId}>
					{label}
				</label>
			)}
			<select id={selectId} className="pf-input pf-select" {...props}>
				<option value="" disabled={placeholderDisabled} hidden={placeholderDisabled}>
					{placeholder}
				</option>
				{options.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
		</div>
	);
}
